import { render, staticRenderFns } from "./OfficerDetailsOverdueLoans.vue?vue&type=template&id=02a59606"
import script from "./OfficerDetailsOverdueLoans.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsOverdueLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports